import axios from 'axios';

// La URL base de la API se toma de las variables de entorno (.env, .env.development, .env.production)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1/';

const API = axios.create({
    baseURL: API_BASE_URL,
});

// Interceptor para agregar el token a las peticiones
API.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Interceptor para manejar errores de autenticación
API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Funciones de Autenticación
export const getToken = async (email, password) => {
    try {
        const response = await API.post('/token', `grant_type=password&username=${email}&password=${password}`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        return response.data.access_token;
    } catch (error) {
        // console.error('Error obteniendo el token:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const getUserInfo = async (token) => {
    try {
        const response = await API.get('/me', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        // console.error('Error obteniendo la información del usuario:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
}

// Funciones para el CRUD de usuarios
export const getUsers = async () => {
    try {
        const response = await API.get('/users/');
        return response.data;
    } catch (error) {
        // console.error('Error al obtener usuarios:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const createUser = async (userData) => {
    try {
        const response = await API.post('/users/', userData);
        return response.data;
    } catch (error) {
        // console.error('Error al crear usuario:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const updateUser = async (email, userData) => {
    try {
        const response = await API.put(`/users/${email}`, userData);
        return response.data;
    } catch (error) {
        // console.error('Error al actualizar usuario:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail); // Reenviar el error del backend con el mensaje
        }
        throw error;
    }
};

export const deleteUser = async (email) => {
    try {
        const response = await API.delete(`/users/${email}`);
        return response.data;
    } catch (error) {
        // console.error('Error al eliminar usuario:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

//Funciones para los pasos
export const getSteps = async () => {
    try {
        const response = await API.get('/steps/');
        return response.data;
    } catch (error) {
        // console.error('Error al obtener los pasos:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const updateUserStep = async (email, newStep) => {
    try {
        const response = await API.put(`/users/${email}/step`, { new_step: newStep }); //ruta correcta
        return response.data;
    } catch (error) {
        // console.error('Error al actualizar el paso del usuario:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

//Funciones para los tutoriales

export const getTutorials = async () => {
    try {
        const response = await API.get('/tutorials/');
        return response.data;
    } catch (error) {
        // console.error('Error al obtener los tutoriales:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const createTutorial = async (tutorialData) => {
    try {
        const response = await API.post('/tutorials/', tutorialData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        // console.error('Error al crear el tutorial:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const updateTutorial = async (id, tutorialData) => { //se ha modificado
    try {
        const response = await API.put(`/tutorials/${id}`, tutorialData, { //se ha modificado
            headers: {
                'Content-Type': 'multipart/form-data' //se ha añadido esto
            }
        });
        return response.data;
    } catch (error) {
        // console.error('Error al actualizar el tutorial:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const deleteTutorial = async (id) => {
    try {
        const response = await API.delete(`/tutorials/${id}`);
        return response.data;
    } catch (error) {
        // console.error('Error al eliminar el tutorial:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

// Funciones para las citas
export const getAppointments = async () => {
    try {
        const response = await API.get('/appointments/');
        return response.data;
    } catch (error) {
        // console.error('Error al obtener las citas:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const getAppointmentById = async (id) => { //se ha modificado
    try {
        const response = await API.get(`/appointments/appointment/${id}`);
        return response.data;
    } catch (error) {
        // console.error('Error al obtener la cita:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const createAppointment = async (appointmentData) => {
    try {
        const response = await API.post('/appointments/', appointmentData);
        return response.data;
    } catch (error) {
        // console.error('Error al crear la cita:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const updateAppointment = async (id, appointmentData) => {
    try {
        const response = await API.put(`/appointments/${id}`, appointmentData);
        return response.data;
    } catch (error) {
        // console.error('Error al actualizar la cita:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const deleteAppointment = async (id) => {
    try {
        const response = await API.delete(`/appointments/${id}`);
        return response.data;
    } catch (error) {
        // console.error('Error al eliminar la cita:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

// Funciones para las Notificaciones
export const getAllNotifications = async () => {
    try {
        const response = await API.get('/notifications/');
        return response.data;
    } catch (error) {
        // console.error('Error al obtener todas las notificaciones:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const getNotificationsByUser = async (user_email) => {
    try {
        const response = await API.get(`/notifications/user/${user_email}`);
        return response.data;
    } catch (error) {
        // console.error('Error al obtener las notificaciones del usuario:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const createNotification = async (notificationData) => {
    try {
        const response = await API.post('/notifications/', notificationData);
        return response.data;
    } catch (error) {
        // console.error('Error al crear la notificación:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const updateNotification = async (notificationId, notificationData) => {
    try {
        const response = await API.put(`/notifications/${notificationId}`, notificationData);
        return response.data;
    } catch (error) {
        // console.error('Error al actualizar la notificación:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const deleteNotification = async (notificationId) => {
    try {
        const response = await API.delete(`/notifications/${notificationId}`);
        return response.data;
    } catch (error) {
        // console.error('Error al eliminar la notificación:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const getNotificationById = async (notificationId) => {
    try {
        const response = await API.get(`/notifications/${notificationId}`);
        return response.data;
    } catch (error) {
        // console.error('Error al obtener la notificación:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const markNotificationAsViewed = async (notificationId) => {
    try {
        const response = await API.put(`/notifications/${notificationId}/view`);
        return response.data;
    } catch (error) {
        // console.error('Error al marcar la notificación como vista:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

/// Funciones para los links
export const getLinks = async () => {
    try {
        const response = await API.get('/links/');
        return response.data;
    } catch (error) {
        // console.error('Error al obtener los links:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const createLink = async (linkData) => {
    try {
        const response = await API.post('/links/', linkData);
        return response.data;
    } catch (error) {
        // console.error('Error al crear el link:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const updateLink = async (id, linkData) => {
    try {
        const response = await API.put(`/links/${id}`, linkData); //se envia linkData
        // console.log("Respuesta de updateLink:", response); // Eliminado
        return response.data;
    } catch (error) {
        // console.error('Error al actualizar el link:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const deleteLink = async (id) => {
    try {
        const response = await API.delete(`/links/${id}`);
        return response.data;
    } catch (error) {
        // console.error('Error al eliminar el link:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const getLinkById = async (id) => {
    try {
        const response = await API.get(`/links/${id}`);
        // console.log("Respuesta de getLinkById:", response.data); // Eliminado
        return response.data;
    } catch (error) {
        // console.error('Error al obtener el link:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};


// Funciones para las preguntas
export const getQuestions = async () => {
    try {
        const response = await API.get('/questions/');
        return response.data;
    } catch (error) {
        // console.error('Error al obtener las preguntas:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const createQuestion = async (questionData) => {
    try {
        const response = await API.post('/questions/', questionData);
        return response.data;
    } catch (error) {
        // console.error('Error al crear la pregunta:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const updateQuestion = async (id, questionData) => {
    try {
        const response = await API.put(`/questions/${id}`, questionData);
        return response.data;
    } catch (error) {
        // console.error('Error al actualizar la pregunta:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const deleteQuestion = async (id) => {
    try {
        const response = await API.delete(`/questions/${id}`);
        return response.data;
    } catch (error) {
        // console.error('Error al eliminar la pregunta:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const getQuestionById = async (id) => {
    try {
        const response = await API.get(`/questions/${id}`);
        return response.data;
    } catch (error) {
        // console.error('Error al obtener la pregunta:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

// Dentro de api.js
export const createLead = async (leadData) => {
    try {
        // Asume que tu endpoint es /leads y no requiere autenticación
        // Si SÍ requiere autenticación, el interceptor ya añade el token
        // Si NO requiere autenticación, puedes crear otra instancia de Axios sin interceptores
        // o simplemente usar API.post y el backend no validará token para esta ruta específica.
        // La opción más simple es usar API.post si el backend lo permite.
        const response = await API.post('/leads', leadData); // Ajusta la ruta si es diferente
        return response.data;
    } catch (error) {
        // console.error('Error al crear lead:', error); // Eliminado
        if (error.response && error.response.data && error.response.data.detail) {
            // Si detail es un array (FastAPI validation error), únelos o toma el primero
            if (Array.isArray(error.response.data.detail)) {
                const messages = error.response.data.detail.map(err => `${err.loc[1]}: ${err.msg}`).join(', ');
                throw new Error(messages || 'Error de validación.');
            }
            throw new Error(error.response.data.detail);
        }
        throw error; // Lanza el error para que el componente lo maneje
    }
};
// --- Añade esto dentro de api.js ---

export const downloadTutorial = async (id) => {
    try {
        const response = await API.get(`/tutorials/download/${id}`, {
            responseType: 'blob', // Importante para manejar archivos binarios
        });
        // Extraer nombre del archivo del header Content-Disposition
        const contentDisposition = response.headers['content-disposition'];
        let filename = `tutorial_${id}.pdf`; // Nombre por defecto
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
            if (filenameMatch && filenameMatch.length > 1) {
                filename = filenameMatch[1];
            }
        }
        return { blob: response.data, filename: filename };
    } catch (error) {
        // Intenta leer el error como JSON si es posible (backend podría enviar error en lugar de blob)
        if (error.response && error.response.data instanceof Blob) {
            try {
                const errorText = await error.response.data.text();
                const errorJson = JSON.parse(errorText);
                if (errorJson.detail) {
                    throw new Error(errorJson.detail);
                }
            } catch (parseError) {
                // Si no se puede parsear como JSON, usa un mensaje genérico
                throw new Error('Error al descargar el archivo. Respuesta inesperada del servidor.');
            }
        } else if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error; // Lanza el error original o el formateado
    }
};
// --- Fin de la función a añadir en api.js ---

// --- Ficha Oncológica API ---
// These functions communicate with the new /api/v1/oncology endpoints.
// getFicha: Retrieves the full oncology record (migrated from SQL to Mongo Document)
// updateFicha: Creates or updates the record using Upsert logic.

export const getFicha = async (patientId) => {
    try {
        const response = await API.get(`/oncology/patient/${patientId}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 404) {
            return null; // No ficha yet
        }
        if (error.response && error.response.data && error.response.data.detail) {
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export const updateFicha = async (patientId, fichaData) => {
    try {
        const response = await API.post(`/oncology/patient/${patientId}`, fichaData);
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.detail) {
            // Handle validation errors similar to createLead
            if (Array.isArray(error.response.data.detail)) {
                const messages = error.response.data.detail.map(err => `${err.loc[1]}: ${err.msg}`).join(', ');
                throw new Error(messages || 'Error de validación.');
            }
            throw new Error(error.response.data.detail);
        }
        throw error;
    }
};

export default API;


// ============================================================
// Chat — Interview Definitions (Builder)
// ============================================================

export const getInterviewDefinitions = async () => {
    try {
        const response = await API.get('/chat/definitions/');
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const getInterviewDefinition = async (id) => {
    try {
        const response = await API.get(`/chat/definitions/${id}`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const createInterviewDefinition = async (data) => {
    try {
        const response = await API.post('/chat/definitions/', data);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const updateInterviewDefinition = async (id, data) => {
    try {
        const response = await API.put(`/chat/definitions/${id}`, data);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const deleteInterviewDefinition = async (id) => {
    try {
        const response = await API.delete(`/chat/definitions/${id}`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

// ============================================================
// Chat — Submissions (Respuestas)
// ============================================================

export const getSubmissions = async (status, userId) => {
    try {
        const params = {};
        if (status) params.status = status;
        if (userId) params.user_id = userId;
        const response = await API.get('/chat/submissions', { params });
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const getSubmission = async (id) => {
    try {
        const response = await API.get(`/chat/submissions/${id}`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const reactivateSubmission = async (id) => {
    try {
        const response = await API.put(`/chat/submissions/${id}/reactivate`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

// ============================================================
// Chat — Test Chat
// ============================================================

export const sendTestMessage = async (content) => {
    try {
        const formData = new FormData();
        formData.append('content', content);
        const response = await API.post('/chat/messages', formData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const getChatHistory = async (limit = 50, offset = 0) => {
    try {
        const response = await API.get('/chat/history', { params: { limit, offset } });
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

// ============================================================
// Chat — Patient Groups & Stages
// ============================================================

export const getPatientGroups = async () => {
    try {
        const response = await API.get('/chat/groups/');
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const getPatientGroup = async (id) => {
    try {
        const response = await API.get(`/chat/groups/${id}`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const createPatientGroup = async (data) => {
    try {
        const response = await API.post('/chat/groups/', data);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const updatePatientGroup = async (id, data) => {
    try {
        const response = await API.put(`/chat/groups/${id}`, data);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const deletePatientGroup = async (id) => {
    try {
        const response = await API.delete(`/chat/groups/${id}`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const assignPatientToGroup = async (groupId, patientId) => {
    try {
        const response = await API.post(`/chat/groups/${groupId}/assign`, {
            patient_id: patientId,
        });
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const unassignPatientFromGroup = async (groupId, patientId) => {
    try {
        const response = await API.post(`/chat/groups/${groupId}/unassign`, {
            patient_id: patientId,
        });
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};

export const getGroupPatients = async (groupId) => {
    try {
        const response = await API.get(`/chat/groups/${groupId}/patients`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.detail) throw new Error(error.response.data.detail);
        throw error;
    }
};
